
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppButton, AppSelect, AppCard, AppFileUpload, AppImageHolder } from '@/components';
import { useBoosterItemEdit } from '@/modules/booster/model/edit';
import { ROUTE_NAME_BOOSTER } from '@/modules/booster/router';

export default defineComponent({
    name: ROUTE_NAME_BOOSTER.EDIT,
    components: { AppFormRow, AppInput, AppButton, AppSelect, AppCard, AppFileUpload, AppImageHolder },
    setup() {
        const { v$, model, fetch, actions, Options } = useBoosterItemEdit();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, fetch, actions, Options };
    }
});
